<script>
import $ from "jquery";

export default {
    name: "Loader",
    props: { loader: Object },
    data: () => ({
        pageData: null,
        interval: null,
        angle: 0
    }),
    methods: {
        Start: function() {
            const loaderContentStateClass = !this.loader.fadeContent ? "disabled" : "disabled-fade";
            $(this.loader.content).addClass(loaderContentStateClass);
            if (!this.loader.positionRelative) {
                this.angle = 0;

                // Animate spinner
                const pageData = this;
                const instance = function() {
                    $(".loader img").css({
                        "-webkit-transform": `rotate(${pageData.angle}deg)`,
                        "-moz-transform": `rotate(${pageData.angle}deg)`,
                        "-ms-transform": `rotate(${pageData.angle}deg)`
                    });
                    pageData.angle++;
                };
                this.interval = window.setInterval(instance, 5);

            }
        },
        Stop: function() {
            $(this.loader.content).removeClass("disabled");
            $(this.loader.content).removeClass("disabled-fade");
            if (!this.loader.positionRelative) {
                this.angle = 0;
                window.clearInterval(this.interval);
            }
        },
        Classes: function() {
            return {
                overlayType: !this.loader.overlayStatic ? "" : "loader-overlay-relative",
                loaderPosition: !this.loader.overlayStatic ? "" : "loader-content-aligned"
            };
        }
    },
    updated: function() {
        if (this.loader.show) {
            this.Start(this.loader.content);
        } else {
            this.Stop();
        }
    }
};
</script>

<template>
    <div v-if="!loader.positionRelative">
        <div :class="['loader-overlay', Classes().overlayType]" v-if="loader.show"></div>
        <div :class="['loader flex-center', Classes().loaderPosition]" v-if="loader.show">
            <img src="@/assets/Images/Loader.png" alt="Loader" title="Loader" width="75" height="75"/>
        </div>
    </div>
    <div v-else>
        <div class="loader loader-static">
            <img src="@/assets/Images/Loader.png" alt="Loader" title="Loader"/>
        </div>
    </div>
</template>